import { render, staticRenderFns } from "./AddAttr.vue?vue&type=template&id=f0b956f0"
import script from "./AddAttr.vue?vue&type=script&lang=js"
export * from "./AddAttr.vue?vue&type=script&lang=js"
import style0 from "./AddAttr.vue?vue&type=style&index=0&id=f0b956f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports